<template>
	<div class="saleable-search-box">
		<div class="filters-box-row" :style="collapse ? 'height: 50px' : ''">
			<div class="filters-container">
				<div class="input-box">
					<span>商品编号：</span>
					<el-input
						v-model="productCode"
						placeholder="请输入商品/规格编号"
						class="filter-input"
						size="small"
						@keyup.enter.native="search"
					></el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						v-model="productName"
						placeholder="请输入商品名称"
						class="filter-input"
						size="small"
						@keyup.enter.native="search"
					></el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>启用状态：</span>
					<el-select v-model="disabledflag" class="filter-input" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="启用"></el-option>
						<el-option :value="1" label="禁用"></el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>店铺级大类：</span>
					<el-select v-model="bigTypeCategory" class="filter-input" size='small' @change="bcChange">
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in bc">
							<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
						</template>
					</el-select>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box" v-if="bigcategoryview === 1">
					<span>店铺级小类：</span>
					<el-select v-model="smallTypeCategory" class="filter-input" size='small'>
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in sc">
							<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
						</template>
					</el-select>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>私密状态：</span>
					<el-select v-model="hiddenflag" class="filter-input" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="公开"></el-option>
						<el-option :value="1" label="私密"></el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container" v-if="freightType !== 1">
				<div class="input-box">
					<span>运费：</span>
					<el-select v-model="usesystemfreightflag" class="filter-input" size='small'>
						<el-option :value="null" label="全部"></el-option>
						<el-option :value="0" label="按件数"></el-option>
						<el-option :value="1" label="按重量"></el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container" v-if="matchbillcenterflag">
				<div class="input-box">
					<span>第三方编号：</span>
					<el-input
						v-model="matchCode"
						placeholder="请输入第三方编号"
						class="filter-input"
						size="small"
						@keyup.enter.native="search"
					></el-input>
				</div>
			</div>
			<div class="filters-container" v-if="matchbillcenterflag">
				<div class="input-box">
					<span>订单中台商品名称：</span>
					<el-input
						v-model="matchname"
						placeholder="请输入订单中台商品名称"
						class="filter-input"
						size="small"
						@keyup.enter.native="search"
					></el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>店铺名称：</span>
					<el-select v-model="shopIds"  multiple collapse-tags class="filter-input" size='small'>
						<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id"></el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>未登录时是否显示：</span>
					<el-select v-model="loginflag" class="filter-input" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="不显示"></el-option>
						<el-option :value="1" label="显示"></el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>是否可见：</span>
					<el-select v-model="visibleflag" class="filter-input" size='small'>
						<el-option :value="null" label="全部"></el-option>
						<el-option :value="false" label="不可见"></el-option>
						<el-option :value="true" label="可见"></el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>是否是组合品：</span>
					<el-select v-model="producttype" class="filter-input" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="1" label="是"></el-option>
						<el-option :value="0" label="否"></el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="search-right-wrap">
			<el-button size="small" type="text" class="btn" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button>
			<el-button size="small" type="primary" class="btn" @click="search">查询</el-button>
			<el-button size="small" plain class="btn" @click="clear">清空</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	props: {
		page: Number,
		size: Number,
		freightType: Number,
		showFlag: Boolean,
		shopid: Array
	},
	data () {
		return {
			shopList: [],
			shopIds: [],
			subtitle: '',
			freightTemplateid: '',
			stackFlag: 2,
			productName: '',
			productCode: '',
			bigTypeCategory: '0',
			smallTypeCategory: '0',
			disabledflag: -1,
			loginflag: -1,
			hiddenflag: -1,
			producttype: -1,
			visibleflag: null,
			saleState: 2,
			auditState: 4,
			collapse: true,
			freightList: [],
			bc: [],
			sc: [],
			bigcategoryview: 0,
			matchbillcenterflag: false,
			matchname: '',
			matchCode: '',
			usesystemfreightflag: null
		}
	},
	created () {
		// this.getBigCategory()
		this.checkSmallCategory().then(res => {
			this.getBigCategory()
			this.bigcategoryview = res.bigcategoryview
			this.matchbillcenterflag = res.matchbillcenterflag === 1
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		})
		let params = window.sessionStorage.getItem('goodsParams')
		params = JSON.parse(params)
		if (params) {
			this.bigTypeCategory = params.bigTypeCategory
			this.smallTypeCategory = params.smallTypeCategory
			this.hiddenflag = params.hiddenflag
			this.producttype = params.producttype
			this.productName = params.productName
			this.productCode = params.productCode
			this.disabledflag = params.disabledflag
			this.loginflag = params.loginflag
			this.matchname = params.matchname
			this.matchCode = params.matchCode
			this.usesystemfreightflag = params.usesystemfreightflag
		}
		this.getShopList()
		this.shopIds = this.shopid
	},
	methods: {
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectOrganList`
			}).then(res => {
				this.shopList = res[0].shopInfoList
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bigTypeCategory
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		search () {
			let params = {
				shopIds: this.shopIds,
				bigTypeCategory: this.bigTypeCategory,
				smallTypeCategory: this.smallTypeCategory,
				hiddenflag: this.hiddenflag,
				productName: this.productName,
				productCode: this.productCode,
				disabledflag: this.disabledflag,
				showflag: this.loginflag,
				matchname: this.matchname,
				matchCode: this.matchCode,
				visibleflag: this.visibleflag,
				usesystemfreightflag: this.usesystemfreightflag,
				producttype: this.producttype,
				page: 1,
				size: this.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/productlist`,
				data: params
			}).then(res => {
				if (res.recordCount !== 0) {
					res.recordList.forEach(e => {
						if (this.showFlag) {
							e.showFlag = false
						} else {
							e.showFlag = true
						}
						e.bold = false
						e.bold2 = false
						if (this.productCode && e.productcode.indexOf(this.productCode) !== -1) {
							e.bold = true
						}
						e.spec.forEach(item => {
							item.bold = false
							item.bold2 = false
							if (this.productCode && item.code.indexOf(this.productCode) !== -1) {
								item.bold = true
							}
							item.price = +item.price < 0 ? '' : item.price
						})
					})
				}
				window.sessionStorage.removeItem('goodsParams')
				this.$emit('getTableData', res)
				this.$emit('getParamsData', params)
			})
		},
		clear () {
			this.shopIds = []
			this.productName = ''
			this.productCode = ''
			this.matchCode = ''
			this.bigTypeCategory = '0'
			this.smallTypeCategory = '0'
			this.getSmalCategory()
			this.hiddenflag = -1
			this.disabledflag = -1
			this.producttype = -1
			this.loginflag = -1
			this.visibleflag = null
			this.usesystemfreightflag = null
			this.search()
		},
		bcChange (value) {
			this.smallTypeCategory = '0'
			this.bigTypeCategory = '' + value
			this.getSmalCategory()
		}
	}
}
</script>

<style lang="stylus" scoped>
.saleable-search-box {
	display: flex
}
.filters-box-row {
	display: flex;
	flex-wrap: wrap;
	overflow: hidden
	// flex-direction column
	// padding: 10px 0;
	// width :100%;
	line-height :50px;
	// min-width :600px;
	box-sizing: border-box;
	// flex-wrap: wrap;
	.filters-container {
		// display flex
		// flex: 1
		height :50px
		.input-box {
			display flex
			// margin-left: 15px
			span {
				display: inline-block;
				text-align: right;
				width: 115px;
				margin-right: 5px
			}
			.filter-input {
				width: 180px
			}
		}
	}
}
.search-right-wrap {
	width: 200px;
	flex-shrink: 0;
	line-height: 50px
}
</style>
